import React from 'react';
import ReactTable from "react-table";

export default class Component extends React.Component {

  render() {

    return (
      <div class="box"></div>
    );
  }
}